import styled from 'styled-components'

export const CreateGroupForm = styled.form`
  margin: auto;
  max-width: 55rem;
`
